var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.552,
    height: 51.552,
    viewBox: "0 0 51.552 51.552",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_111030_share_icon",
    "data-name": "111030_share_icon",
    d: "M31.949,79.206a4.3,4.3,0,0,0,4.3,4.3h42.96a4.3,4.3,0,0,0,4.3-4.3V36.246a4.3,4.3,0,0,0-4.3-4.3H36.245a4.3,4.3,0,0,0-4.3,4.3v42.96Zm9.666-21.48A6.45,6.45,0,0,1,51.99,52.614l8.978-4.07a3.761,3.761,0,0,1-.021-.483,6.45,6.45,0,1,1,2.137,4.79l-8.656,3.931a5.994,5.994,0,0,1,0,1.89l8.656,3.92a6.449,6.449,0,1,1-2.137,4.8,3.765,3.765,0,0,1,.021-.484L51.99,62.828a6.44,6.44,0,0,1-10.375-5.1Z",
    transform: "translate(-31.949 -31.95)",
    fill: "#f16521",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-icon.65a3881981fda1c24b68131c432ce1f9.svg";